var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130,
    height: "auto",
    viewBox: "0 0 172.913 59.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1.112,
    x2: 0.5,
    y2: -0.148,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0086cd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172.913,
    height: 59.528
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.48,55.632V17.987c0-9.266,5.638-14.275,15.539-14.836V40.093A15.585,15.585,0,0,1,27.48,55.632Zm-8.98,0V17.987c0-9.266-5.638-14.275-15.539-14.836V40.093A15.584,15.584,0,0,0,18.5,55.632Z",
    fillRule: "evenodd",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.586,44.3A2.711,2.711,0,0,1,25.688,47v7.678a2.734,2.734,0,0,1-2.734,2.734H22.9a2.477,2.477,0,0,1-2.476-2.476v-8.05A2.639,2.639,0,0,1,23.586,44.3Z",
    fill: "#004071",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.248,29.391a3.513,3.513,0,1,1-3.513-3.512A3.513,3.513,0,0,1,57.248,29.391Z",
    fill: "#ed6c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.649,38.387H89.116a2.094,2.094,0,1,0,0-4.188H77.649a9.374,9.374,0,0,1,0-18.747h15a3.668,3.668,0,0,1,3.663,3.663,2.094,2.094,0,1,0,4.188,0,7.859,7.859,0,0,0-7.85-7.851h-15a13.562,13.562,0,1,0,0,27.123Z",
    fill: "#004071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.706,26.7a13.476,13.476,0,0,0-9.59-3.972H77.649a2.094,2.094,0,1,0,0,4.189H89.116a9.373,9.373,0,1,1,0,18.746h-15A3.667,3.667,0,0,1,70.453,42a2.095,2.095,0,0,0-4.189,0,7.861,7.861,0,0,0,7.851,7.852h15A13.562,13.562,0,0,0,98.706,26.7Z",
    fill: "#004071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.717,11.28H105.061a2.132,2.132,0,0,0,0,4.263h12.7v32.18a2.131,2.131,0,1,0,4.263,0V15.543h12.7a2.132,2.132,0,1,0,0-4.263Z",
    fill: "#004071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.607,49.855H148.82A11.97,11.97,0,0,1,136.864,37.9V23.163a11.9,11.9,0,0,1,11.882-11.882h11.861a10.068,10.068,0,0,1,10.057,10.057,2.131,2.131,0,0,1-4.262,0,5.8,5.8,0,0,0-5.795-5.794H148.746a7.628,7.628,0,0,0-7.619,7.619V37.9a7.7,7.7,0,0,0,7.693,7.693h11.787A5.8,5.8,0,0,0,166.4,39.8a2.131,2.131,0,0,1,4.262,0A10.068,10.068,0,0,1,160.607,49.855Z",
    fill: "#004071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.48,55.632V17.987c0-9.266,5.638-14.275,15.539-14.836V40.093A15.585,15.585,0,0,1,27.48,55.632Zm-8.98,0V17.987c0-9.266-5.638-14.275-15.539-14.836V40.093A15.584,15.584,0,0,0,18.5,55.632Z",
    fillRule: "evenodd",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.586,44.3A2.711,2.711,0,0,1,25.688,47v7.678a2.734,2.734,0,0,1-2.734,2.734H22.9a2.477,2.477,0,0,1-2.476-2.476v-8.05A2.639,2.639,0,0,1,23.586,44.3Z",
    fill: "#004071",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.248,29.391a3.513,3.513,0,1,1-3.513-3.512A3.513,3.513,0,0,1,57.248,29.391Z",
    fill: "#ed6c1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.649,38.387H89.116a2.094,2.094,0,1,0,0-4.188H77.649a9.374,9.374,0,0,1,0-18.747h15a3.668,3.668,0,0,1,3.663,3.663,2.094,2.094,0,1,0,4.188,0,7.859,7.859,0,0,0-7.85-7.851h-15a13.562,13.562,0,1,0,0,27.123Z",
    fill: "#004071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.706,26.7a13.476,13.476,0,0,0-9.59-3.972H77.649a2.094,2.094,0,1,0,0,4.189H89.116a9.373,9.373,0,1,1,0,18.746h-15A3.667,3.667,0,0,1,70.453,42a2.095,2.095,0,0,0-4.189,0,7.861,7.861,0,0,0,7.851,7.852h15A13.562,13.562,0,0,0,98.706,26.7Z",
    fill: "#004071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.717,11.28H105.061a2.132,2.132,0,0,0,0,4.263h12.7v32.18a2.131,2.131,0,1,0,4.263,0V15.543h12.7a2.132,2.132,0,1,0,0-4.263Z",
    fill: "#004071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.607,49.855H148.82A11.97,11.97,0,0,1,136.864,37.9V23.163a11.9,11.9,0,0,1,11.882-11.882h11.861a10.068,10.068,0,0,1,10.057,10.057,2.131,2.131,0,0,1-4.262,0,5.8,5.8,0,0,0-5.795-5.794H148.746a7.628,7.628,0,0,0-7.619,7.619V37.9a7.7,7.7,0,0,0,7.693,7.693h11.787A5.8,5.8,0,0,0,166.4,39.8a2.131,2.131,0,0,1,4.262,0A10.068,10.068,0,0,1,160.607,49.855Z",
    fill: "#004071"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.57cc9908456e2367cc4dbc770568e107.svg";
export { ForwardRef as ReactComponent };